// TODO(pkmng-143): Remove this file once the API exposes `townMapPosition`
// on the Location endpoint. This mirrors pkmng-mgmt-v2/app/data/locationMeta.ts
// so the client can render locations on the town map without blocking on
// backend work.
//
// The grid uses the full-region coordinate system from the mgmt app
// (90 columns × 60 rows at 8px/cell over the 720×480 region map). Rows
// and columns are 1-indexed to match pkmng-mgmt-v2's grid; mgmt-v2
// subtracts 1 before converting to pixels. The in-game town map shows
// the middle 30×20 window (columns 31-60, rows 21-40) at 8px/cell,
// totaling 240×160 pixels.
//
// See `townMapGridToPixel()` in `src/ui/TownMapMenu.js` for the translation.

export type TownMapPosition = {
    row: number;
    column: number;
};

export const TOWN_MAP_POSITIONS: Record<string, TownMapPosition> = {
    bramblecrest: { row: 30, column: 47 },
    route01: { row: 30, column: 48 },
    mistral_heights: { row: 30, column: 49 },
    route02: { row: 30, column: 50 },
    vine_cave: { row: 30, column: 51 },
};

export function getTownMapPosition(locationId: string): TownMapPosition | null {
    return TOWN_MAP_POSITIONS[locationId] ?? null;
}
